/**
 * @generated SignedSource<<89ab72a00d50d9fb721326b9937f12c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpsertDpcForm_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ACLFormFields_query" | "AccountGroupPicker_accountGroups">;
  readonly " $fragmentType": "UpsertDpcForm_query";
};
export type UpsertDpcForm_query$key = {
  readonly " $data"?: UpsertDpcForm_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpsertDpcForm_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpsertDpcForm_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ACLFormFields_query"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "kind": "FragmentSpread",
      "name": "AccountGroupPicker_accountGroups"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "197cd3c10218ec4823b3284a9794bd43";

export default node;
